function removeNonNumericNonHyphenCharacters(input: string) {
  return input.replace(/[^0-9-]/g, '');
}

export const toZipCode: React.FormEventHandler<HTMLInputElement> = (e) => {
  const target = e.target as HTMLInputElement;
  target.value = target.value ? removeNonNumericNonHyphenCharacters(target.value) : '';
};
